


const returnAnims = () => {


    const data = {
        "data": {
            
            "#demoElement":{
                "parallax":{
                    "properties":{
                        "translateY":{
                            "30":"-200px",
                            "70":"200px"
                        },
                        "rotateZ":{
                            "30":"90deg",
                            "70":"-90deg"
                        }
                    },
                    "lerp": 0.06
                }
            },
            ".zoomClaim":{
                "parallax":{
                    "properties":{
                        "opacity":{
                            "80":"100",
                            "90":"0"
                        },
                        "translateY":{
                            "90":"50px",
                            "80":"0px"
                        },
                        "scale":{
                            "90":"105%",
                            "80":"100%"
                        }
                    },
                    "lerp": 0.06
                }
            },
            ".lerpCursorStatic":{
                "parallax":{
                    "properties":{
                        "translateX":{
                            "40":"800px",
                            "70":"0px"
                        }
                    },
                  
                }
            },
            ".lerpCursor":{
                "parallax":{
                    "properties":{
                        "translateX":{
                            "40":"800px",
                            "70":"0px"
                        }
                    },
                    "lerp": 0.09
                }
            },
            ".scrollSquare":{
                "parallax":{
                    "properties":{
                        "translateX":{
                            "58":"-200px",
                            "30":"200px"
                        },
                        "rotateZ":{
                            "58":"0deg",
                            "30":"180deg"
                        }
                    },
                    "lerp": 0.1
                }
            },
            ".scrollLine":{
                "parallax":{
                    "properties":{
                        "translateX":{
                            "100":"0px",
                            "42":"980px",
                        }
                    }
                }
            },
            
         "#parallaxExample": {
          "parallax": {
           "properties": {
            "opacity": {
                "10":"0",
                "75": "100",
                "25": "100",
                "90":"0"
              },
            
               "translateY": {
                "50": "0px",
                "20": "200px",
                "80": "-200px"
               },
               "backgroundColor": {
                "25": "#73FFEB",
                "50": "#F64FFF",
                "75": "#738bff"
               },
            
            
           },
           "lerp": 0.1
          }
         }
        },
        "customTimedAnimations": {},
        "usedPresets": {
         "timed": {},
         "parallax": {},
         "scroll": {}
        },
        "descriptions": {},
        "bodyLerp": false
       }


       const operations = [
            [
                [-30,0],
                [120,180]
            ],
            [
                [-140,-90],
                [50,90],
                [-100,-55],
                [0,55],
                [-150,-125],
                [90,125]
            ],
             [
                [-140,-90],
                [40,90],
                [-20,0]
            ] 
       ]

       operations.forEach((o,i)=>{
        i = i+1
        o.forEach((w,k)=>{
            data.data[`#comp-${i}-${k}`] = {
                "parallax":{
                    "properties":{
                        "rotateZ":{
                            "150":`${w[0]}deg`,
                            "40": `${w[1]}deg`
                        }
                    },
                    "lerp": 0.1
                }
            }
        })
       })

        for (let m = 0; m <= 20; m++){
        const v = (m*50)
        data.data['.propChip-'+m] = {
            "parallax":{
                "properties":{
                    "translateX":{
                        "100":v+"px",
                        "50":"0px"
                    },
                    "opacity":{
                        "100":"0",
                        "50":"100"
                    }
                },
                "lerp": 0.1
            }
        }
       } 
       
       
    

    return data;
}

export const defAnims = returnAnims()
